import { MAP_MIN_ZOOM, MAP_MAX_ZOOM } from './MapConstants';

class MapZoomController
{
    constructor(map)
    {
        this.map = map;
        this.sitePinsRef = null;
        this.exteriorMapPinsRef = null;
    }

    setPinRefs(sitePinsRef, exteriorMapPinsRef)
    {
        this.sitePinsRef = sitePinsRef;
        this.exteriorMapPinsRef = exteriorMapPinsRef;
    }

    getTileURL(bfMapState)
    {
        const map_dir = bfMapState ? 'map_bf' : 'map';
        return `${process.env.PUBLIC_URL}/img/${map_dir}/{z}/{x}/{y}.png`;
    }

    updateMarkerZoomLevel(zoomLevel)
    {
        const mapContainer = this.map.getContainer();
        mapContainer.setAttribute('data-marker-zoom-level', zoomLevel);

        this.updateSiteMapPinZoomLevels(zoomLevel);
    }

    updateSiteMapPinZoomLevels(zoomLevel)
    {
        if (this.sitePinsRef?.current)
        {
            this.sitePinsRef.current.forEach(pin =>
            {
                pin.zoomLevel = zoomLevel;
            });
        }

        if (this.exteriorMapPinsRef?.current)
        {
            this.exteriorMapPinsRef.current.forEach(pin =>
            {
                pin.zoomLevel = zoomLevel;
            });
        }
    }

    calculateFontSizeBasedOnZoom(zoomLevel)
    {
        const baseFontSize = 10;
        const zoomLevelBase = 3;
        const zoomMultiplier = 1.5;

        return baseFontSize * Math.pow(zoomMultiplier, zoomLevel - zoomLevelBase);
    }

    updateLabelFontSize(zoomLevel)
    {
        zoomLevel = Math.max(Math.min(zoomLevel, MAP_MAX_ZOOM), MAP_MIN_ZOOM);
        const newBaseSize = this.calculateFontSizeBasedOnZoom(zoomLevel);
        document.documentElement.style.setProperty('--map-label-fontsize', `${newBaseSize}px`);
    }

    handleZoomIn(zoomLevel, targetZoom)
    {
        this.updateMarkerZoomLevel(zoomLevel);
        // updateLabelFontSize(targetZoom); // Commented out in original
    }

    handleZoomOut(zoomLevel, targetZoom)
    {
        this.updateMarkerZoomLevel(zoomLevel);
        this.updateLabelFontSize(targetZoom);
    }

    onZoomEnd()
    {
        const zoomLevel = this.map.getZoom();
        this.updateMarkerZoomLevel(zoomLevel);
        this.updateLabelFontSize(zoomLevel);
    }
}

export default MapZoomController; 